import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5954443c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5954443c&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=5954443c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5954443c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5954443c')) {
      api.createRecord('5954443c', component.options)
    } else {
      api.reload('5954443c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5954443c&scoped=true&", function () {
      api.rerender('5954443c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/index.vue"
export default component.exports